function isGroupedItems(items) {
  return items.length > 0 && !('value' in items[0]);
}

export default isGroupedItems;
